module.exports = __webpack_public_path__ + "static/media/leftArrowCalendar.4f29f234.svg";